import { ThreadStatus } from '@langchain/langgraph-sdk';

import { useMemo } from 'react';

import { GroupedTabs } from '@/design-system/components/GroupedTabs/GroupedTabs';
import { cn } from '@/utils/tailwind';

import { THREAD_STATUS_MAP } from '../../constants';

export const ThreadsFilterBar = ({
  selectedStatusFilter,
  setSelectedStatusFilter,
}: {
  selectedStatusFilter: ThreadStatus | 'all';
  setSelectedStatusFilter: (status: ThreadStatus | 'all') => void;
}) => {
  const options = useMemo(() => {
    return [
      {
        display: 'All',
        value: 'all',
      },
      ...Object.entries(THREAD_STATUS_MAP).map(
        ([status, { label, icon: Icon, bgColor, textColor }]) => ({
          display: (
            <div className="flex items-center gap-2">
              <span className="font-medium">{label}</span>
            </div>
          ),
          value: status,
          icon: (
            <div className="p-1">
              <Icon className="size-4" />
            </div>
          ),
          className:
            status === selectedStatusFilter
              ? cn(bgColor, textColor)
              : undefined,
        })
      ),
    ];
  }, [selectedStatusFilter]);
  return (
    <GroupedTabs
      options={options}
      value={selectedStatusFilter}
      onChange={(value) => {
        setSelectedStatusFilter(value as ThreadStatus | 'all');
      }}
      className="overflow-x-auto"
    />
  );
};
